import { DevelopMainComponent } from './routes/develop/main.component';
import { DevelopComponent } from './layout/develop.page';
import { ComponentsInputComponent } from './routes/components/simple-input/input.component';
import { ComponentsRangeComponent } from './routes/components/operators-input/range.component';
import { ComponentsOperatorsInputComponent } from './routes/components/operators-input/operators.component';
import { ComponentsComponent } from './layout/components.page';
import { ComponentsSimpleComponent } from './routes/components/simple-input/simple.component';
import { ComponentsRadioSelectSwitchComponent } from './routes/components/simple-input/radioSelectSwitch.component';
import { ComponentsCheckboxListComponent } from './routes/components/simple-input/checkboxList.component';
import { ComponentsInputWithSuggestionsComponent } from './routes/components/simple-input/inputWithSuggestions.component';
import { GettingStartedComponent } from './layout/gettingStarted.page';
import { GettingStartedMainComponent } from './routes/getting-started/main.component';
import { ComponentsInputWithMaskComponent } from './routes/components/simple-input/inputWithMask.component';
import { ApiComponent } from './layout/api.page';
import { ApiMainComponent } from './routes/api/main.component';
var ɵ0 = { title: 'Getting started' }, ɵ1 = { title: 'Simple input' }, ɵ2 = { title: 'Input' }, ɵ3 = { title: 'Input with mask' }, ɵ4 = { title: 'Radio - Select - Switch' }, ɵ5 = { title: 'Checkbox List' }, ɵ6 = { title: 'Input with suggestions' }, ɵ7 = { title: 'General' }, ɵ8 = { title: 'Operators input' }, ɵ9 = { title: 'Range' }, ɵ10 = { title: 'Api' }, ɵ11 = { title: 'Develop' };
var appRoutes = [
    {
        path: '',
        redirectTo: '/getting-started',
        pathMatch: 'full'
    },
    {
        path: 'getting-started',
        component: GettingStartedComponent,
        children: [
            { path: '', component: GettingStartedMainComponent, data: ɵ0 }
        ]
    },
    {
        path: 'components',
        component: ComponentsComponent,
        children: [
            { path: '',
                redirectTo: '/components/simple-input',
                pathMatch: 'full',
            },
            { path: 'simple-input', children: [
                    { path: '', component: ComponentsSimpleComponent, data: ɵ1 },
                    { path: 'input', component: ComponentsInputComponent, data: ɵ2 },
                    { path: 'input-with-mask', component: ComponentsInputWithMaskComponent, data: ɵ3 },
                    { path: 'radio-select-switch', component: ComponentsRadioSelectSwitchComponent, data: ɵ4 },
                    { path: 'checkboxlist', component: ComponentsCheckboxListComponent, data: ɵ5 },
                    { path: 'input-with-suggestions', component: ComponentsInputWithSuggestionsComponent, data: ɵ6 },
                ] },
            { path: 'general', component: ComponentsSimpleComponent, data: ɵ7 },
            { path: 'operators-input', children: [
                    { path: '', component: ComponentsOperatorsInputComponent, data: ɵ8 },
                    { path: 'range', component: ComponentsRangeComponent, data: ɵ9 }
                ] }
        ]
    },
    {
        path: 'api',
        component: ApiComponent,
        children: [
            { path: '', component: ApiMainComponent, data: ɵ10 }
        ]
    },
    {
        path: 'develop',
        component: DevelopComponent,
        children: [
            { path: '', component: DevelopMainComponent, data: ɵ11 }
        ]
    }
];
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11 };
